import { Outlet, useLocation, useOutletContext } from 'react-router-dom';
import type { SellerSummary } from '@seller-portal/types';
import { consoleHomePath, useSession } from '@/auth/session';
import { Page } from './Page';
import { ErrorBoundary } from './ErrorBoundary';

/**
 * The boundary sits above the routed page, so a page's own hooks and render are covered too.
 * The seller from RequireSeller is passed through, and the panel renders inside the shell.
 */
export function PageBoundary() {
  const seller = useOutletContext<SellerSummary | undefined>();
  const { data: me } = useSession();
  const location = useLocation();
  const homeTo = consoleHomePath(me, seller);
  return (
    <ErrorBoundary
      resetKey={location.pathname}
      homeTo={homeTo}
      wrap={(panel) => <Page title="Something went wrong">{panel}</Page>}
    >
      <Outlet context={seller} />
    </ErrorBoundary>
  );
}
